import styled from 'styled-components';

const SeparatorWrapper = styled.div`
    ${({ spacing }) => spacing && 'margin: 15px 0 5px'}
`;

const SeparatorContent = styled.div`
    width: 100%;
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: ${({ spacing }) => spacing ? '40%' : 0};
        left: 0;
        right: 0;
        height: 0;
        width: 100%;
        border-top: 1px solid #ccc;
    }
`;

const SeparatorText = styled.span`
    background: #fbfbfb;
    color: #333;
    display: inline-block;
    margin-left: ${({ marginLeft }) => marginLeft};
    padding: 0 10px;
    position: relative;
    z-index: 2;
`;

export { SeparatorWrapper, SeparatorContent, SeparatorText }